<template>
  <div class="third-step-component">
    <template v-if="isNewOrderPage">
      <result-window v-if="showResultWindow" />
      <payment-window v-else />
    </template>
    <edit-payment-window v-else />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PaymentWindow from '@/components/order-processing/order-components/payment/PaymentWindow.vue'
  import EditPaymentWindow from '@/components/order-processing/order-components/payment/EditPaymentWindow.vue'
  import ResultWindow from '@/components/order-processing/new-order/second-step/result-window/ResultWindow.vue'
  import orderEdit from '@/mixins/order-edit'

  export default {
    name: 'ThirdStep',
    components: {
      EditPaymentWindow,
      PaymentWindow,
      ResultWindow,
    },
    mixins: [
      orderEdit,
    ],
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        showResultWindow: state => state.newOrder.showResultWindow,
      }),
    },
  }
</script>
